import { CurrentUserType } from 'types';
import { EventOptions } from '@amplitude/analytics-types';
import { Scalars } from 'generated/types';

export interface TrackEventType {
  name: string;
  user?: CurrentUserType | null;
  properties?: { [key: string]: any };
  options?: EventOptions;
  path?: string;
}


export const TrackUserId = (userId?: Scalars['ID']) => {
  if (!userId) return;
  return `user_${userId}`;
};